import React, { FC } from "react";
import { IconType } from "./types";

export const RepairIcon: FC<IconType> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M10.4212 5.58758C10.1572 5.32357 10.0252 5.19156 9.97575 5.03934C9.93225 4.90545 9.93225 4.76122 9.97575 4.62732C10.0252 4.4751 10.1572 4.3431 10.4212 4.07908L12.3135 2.18684C11.8113 1.95975 11.2539 1.83333 10.667 1.83333C8.45784 1.83333 6.66698 3.62419 6.66698 5.83333C6.66698 6.16069 6.70631 6.47887 6.78049 6.78339C6.85993 7.10949 6.89965 7.27254 6.8926 7.37555C6.88521 7.48339 6.86913 7.54077 6.8194 7.63674C6.7719 7.72841 6.68089 7.81943 6.49886 8.00145L2.33365 12.1667C1.78136 12.719 1.78136 13.6144 2.33365 14.1667C2.88593 14.719 3.78136 14.719 4.33365 14.1667L8.49886 10.0015C8.68089 9.81943 8.7719 9.72841 8.86357 9.68091C8.95954 9.63118 9.01692 9.6151 9.12476 9.60772C9.22777 9.60066 9.39082 9.64038 9.71692 9.71982C10.0214 9.79401 10.3396 9.83333 10.667 9.83333C12.8761 9.83333 14.667 8.04247 14.667 5.83333C14.667 5.24639 14.5406 4.68898 14.3135 4.18684L12.4212 6.07908C12.1572 6.3431 12.0252 6.4751 11.873 6.52456C11.7391 6.56807 11.5949 6.56807 11.461 6.52456C11.3087 6.4751 11.1767 6.3431 10.9127 6.07908L10.4212 5.58758Z"
      stroke="black"
      stroke-width="1.41667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
